import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=482f5965&scoped=true&lang=pug&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=482f5965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f5965",
  null
  
)

export default component.exports